<div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('assets/images/others/login-3.png')">
    <div class="d-flex flex-column justify-content-between h-100">
        <div class="d-none d-md-block"></div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-7 col-lg-5 m-h-auto">
                    <nz-card class="m-b-60 shadow-lg">
                        <div class="d-flex align-items-center justify-content-between m-b-30">
                            <img class="img-fluid" alt="" src="assets/images/logo/logo.png">
                            <h2 class="m-b-0">Sign Up</h2>
                        </div>
                        <form nz-form [formGroup]="signUpForm" class="login-form" nzLayout="vertical" (ngSubmit)="submitForm()">
                            <nz-form-item>
                                <nz-form-label nzRequired nzFor="userName">Username</nz-form-label>
                                <nz-form-control nzErrorTip="Please input your username!">
                                    <input type="text" nz-input formControlName="userName" placeholder="Username" id="userName">
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                                <nz-form-label nzRequired nzFor="email">Email</nz-form-label>
                                <nz-form-control nzErrorTip="The input is not valid E-mail!">
                                    <input type="text" nz-input formControlName="email" placeholder="Username" id="email">
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                                <nz-form-label nzRequired nzFor="password">Password</nz-form-label>
                                <nz-form-control nzErrorTip="Please input your Password!">
                                    <input type="password" nz-input formControlName="password" placeholder="Password" id="password">
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                                <nz-form-label nzFor="checkPassword" nzRequired>Confirm Password</nz-form-label>
                                <nz-form-control nzErrorTip="Please confirm your password!">
                                    <input nz-input type="password" formControlName="checkPassword"  placeholder="Confirm Password" id="checkPassword">
                                </nz-form-control>
                            </nz-form-item>
                            <div class="d-flex align-items-center justify-content-between">
                                <nz-form-item>
                                    <nz-form-control>
                                        <label nz-checkbox formControlName="agree">
                                            <span>I have read the <a>agreement</a></span>
                                        </label>
                                    </nz-form-control>
                                </nz-form-item>
                                <nz-form-item>
                                    <nz-form-control>
                                        <div >
                                            <button nz-button class="login-form-button" [nzType]="'primary'">Sign Up</button>
                                        </div>
                                    </nz-form-control>
                                </nz-form-item>   
                            </div>
                        </form>
                    </nz-card>
                </div>
            </div>
        </div>
        <div class="d-none d-md-flex p-h-40 justify-content-between">
            <span class="">© 2025 Adpedia</span>
            <ul class="list-inline">
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Legal</a>
                </li>
                <li class="list-inline-item">
                    <a class="text-dark text-link" href="">Privacy</a>
                </li>
            </ul>
        </div>
    </div>
</div>